export const LABELS_TEXT = {
  days: 'дней',
  hours: 'часов',
  minutes: 'минут',
  seconds: 'секунд',
};

export const DAY_MILLISECONDS = 1000 * 3600 * 24;
